import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { File } from 'components/FileUploadMultiple';
import { Row, Col, Modal, Form, Button, Spinner } from 'react-bootstrap';
import {Currency,DollarCurrency,EuroCurrency} from 'helpers/Currency';
import { parseDateBR } from 'helpers/date';
import { connect } from 'react-redux';
import { ASYNC_INVOICE_APPROVAL } from 'store';
import './style.css';
import Can from 'components/Can';
import History from 'components/History';
import Input from 'helpers/Input';
import FormSelectActions from 'components/S3Explorer/Form/FormSelectActions';

const ModalHistoric = ({ data, show, handleHideModalAUX }) => {
  const { t } = useTranslation();

  // const [showModal, setShowModal] = useState(show?show:false);
  const handleHideModal = () => {
    handleHideModalAUX()
    // setShowModal(false);
  };

  const getStatus = () => {
    let approvations = data.approval_history;
    const getIcon = () => {
      if(approvations.filter(a=>a.status_id===8).length > 0){
        return <i className={"fas fa-chevron-circle-right bar-status-icon "+getProgress()+'-icon'}
        data-tip={``}></i>
      }else{
        //<i className="fas fa-chevron-circle-right"></i>
        return <i className={"fas fa-exclamation-circle bar-status-icon bar-status-icon-orange "+getProgress()+'-icon'}
        data-tip={``}></i>
      }
    }
    const getProgress = () => {
      if(approvations.filter(a=>a.status_id===8).length == 1 && approvations.filter(a=>a.status_id===6).length == 1){
        return ' progress-50'
      } else if(approvations.filter(a=>a.status_id===8).length > 0){
        return ' progress-100'
      }else{
        return '';
      }
    }
    return (<>
      <div className='bar-status'>
        <div className={'bar-status-progress'+getProgress()}></div>
        {getIcon()}
      </div>
      <Row className="mt-2">
        <Col className="text-left"><strong>Aguardando Aprovação</strong></Col>
        {approvations.length > 1?(
          <Col className="text-center"><strong>Aguardando Segunda Aprovação</strong></Col>
        ):''}
        <Col className="text-right"><strong>Aprovada</strong></Col>
      </Row>
    </>);
  }

  const getcurrency = (value) => {
    switch (data.currency) {
      case 1:
        return <Currency value={value} disabled />;
        break;
      case 2:
        return <DollarCurrency value={value} disabled />;
        break;
      case 3:
        return <EuroCurrency value={value} disabled />;
        break;
      default:
        return <Currency value={value} disabled />;
        break;
    }
  }


  return (
    <>
    <Modal size="lg" show={show} onHide={handleHideModal}>
      <Modal.Header closeButton>#{data?data.id:''}</Modal.Header>
      <Modal.Body>
        {data?(<>
          <Row className='p-3'>
            <Col xs="12">
            {getStatus()}
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>Analista</Form.Label>
                <Form.Control value={data.creator} disabled />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Fabricante</Form.Label>                
                <Form.Control value={data.company} disabled />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:service provider')}</Form.Label>
                <Form.Control value={data.service_provider} disabled />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:registered number')}</Form.Label>                
                <Input.CNPJ value={data.document} disabled />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:invoice number')}</Form.Label>
                <Form.Control value={data.invoice_number} disabled />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:expiry')}</Form.Label>
                <Form.Control disabled value={data.due_date && parseDateBR(data.due_date)} />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:issuance_date')}</Form.Label>
                <Form.Control disabled value={data.issuance_date && parseDateBR(data.issuance_date)} />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mt-2 mb-1">
            <Col>
              <h5>{t('title:project info')}</h5>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:nature')}</Form.Label>
                <Form.Control value={data.nature} disabled />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:cost center')}</Form.Label>
                <Form.Control value={data.cost_center} disabled />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:project')}</Form.Label>
                <Form.Control value={data.project} disabled />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:project action')}</Form.Label>
                <Form.Control value={data.project_action} disabled />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:value')} - Reembolsável</Form.Label>
                {getcurrency(data.value)}
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:value')} - Não Reembolsável</Form.Label>
                {getcurrency(data.non_refundable)}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:brief description')}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows="4"
                  value={data.description}
                  disabled
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
            {data.files?data.files.map(file=>
              <File
                key={file.id}
                extension={file.extension}
                comment={file.comment}
                uri={file.uri}
              />
            ):(
              <File
                key={data.files.id}
                extension={data.files.extension}
                comment={data.files.comment}
                uri={data.files.uri}
              />
            )}
            </Col>
          </Row>
          
          {data.vinculated && data.vinculated.length > 0 && !data.is_advance ? (
          <Row className="p-1">
            <FormSelectActions 
            disabled={true} 
            list={[]}
            selected={data.vinculated}
            value_nf={data.value}/>
          </Row>
          ):''}

          <History histories={data.histories.reverse()}/>
        </>):<Row className="justify-content-md-center"><Col xs="auto">
      <Spinner animation="border" role="status">
        <span className="sr-only">Loading...</span>
      </Spinner>
    </Col></Row>}
      </Modal.Body>
    </Modal>
    </>
  );
};

export default ModalHistoric;